import { jsx as _jsx } from "react/jsx-runtime";
import { ProductStub } from '../ProductStub';
/** Uptime-scoped Delivery Log — Wave 1 target (mirrors the SSL page). */
export function DeliveryLogPage() {
    return (_jsx(ProductStub, { title: "Delivery log", blurb: "Every uptime alert this org has sent \u2014 status (SENT / FAILED / SKIPPED), channel, recipient, monitor, template, timestamp. Filters the platform-level alert_delivery_log by product='UPTIME'. Ships in Wave 1." }));
}
